import { buildAuthHeaders, buildUrl } from "../../../utils/requestToolsImposto";
import { searchImpostos } from "../../BaseRepositoryComponents";

const path = `${process.env.REACT_APP_URL_API_IMPOSTOS}`;

export async function getPerfilTributario() {
  const url = buildUrl({ path: `${path}/perfil-tributario` });
  return searchImpostos(url, "GET", buildAuthHeaders());
}

export async function getPerfilTributarioDados(perfilId) {
  const url = buildUrl({ path: `${path}/perfil-tributario/${perfilId}` });
  return searchImpostos(url, "GET", buildAuthHeaders());
}

export async function getClassificacaoTributaria() {
  const url = buildUrl({ path: `${path}/ibs-cbs-classificacao-tributaria` });
  return searchImpostos(url, "GET", buildAuthHeaders());
}

export async function getIndicadorOperacao() {
  const url = buildUrl({ path: `${path}/codigo-indicador-tributacao-consumo` });

  return searchImpostos(url, "GET", buildAuthHeaders());
}

export async function getCodigoTributacao() {
  const url = buildUrl({ path: `${path}/codigo-tributacao-nacional` });

  return searchImpostos(url, "GET", buildAuthHeaders());
}

export async function getNbs() {
  const url = buildUrl({ path: `${path}/nbs` });

  return searchImpostos(url, "GET", buildAuthHeaders());
}

export async function getNbsDados(codigo) {
  const url = buildUrl({ path: `${path}/nbs/codigo/${codigo}` });

  return searchImpostos(url, "GET", buildAuthHeaders());
}
